module.exports = __webpack_public_path__ + "static/media/relativebrush.5c9dd1b1.png";